module.exports = __webpack_public_path__ + "img/tipocontacto02.d60d02f.svg";